<template>
    <div>
        <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
            {{ moduleTitle }}
        </ModuleTitleNav>
        <div class="section-line" />
        <fieldset :disabled="formDisabled">
            <b-row>
                <b-col>
                    <div class="info-text-section-marker">
                        [Sec 135(b)(6)]
                    </div>
                    <div class="info-text">
                        Describe how the college will develop and implement
                        evaluations of the activities carried out with Perkins
                        funds, including evaluations necessary to complete the
                        comprehensive needs assessment and the analysis of local
                        accountability performance reports.
                    </div>
                    <b-form-textarea
                        v-model="activityEvaluations"
                        :rows="3"
                    />
                </b-col>
            </b-row>
        </fieldset>
        <br>
        <b-row>
            <b-col>
                <LocalApplicationModuleActions
                    :is-loading="isSaving"
                    :is-disabled="formDisabled"
                    background-color="#006438"
                    @saveForm="saveForm"
                />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';

const storeModuleName = 'evaluationOfPrograms';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'EvaluationOfPrograms',

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Evaluation Of Programs',
            nextModule: { name: 'localApplication.PoolingOfFunds' },
            previousModule: { name: 'localApplication.IncreaseStudentAchievement' },
        };
    },

    computed: {
        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`
        }),

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        activityEvaluations: {
            get() { return this.localApplicationModuleContent.activityEvaluations; },
            set(value) { this.updateContentField({ field: 'activityEvaluations', value }); }
        },
    },


    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}`, {
            saveLocalApplicationModule: 'save',
            updateContentField: 'updateContentField'
        }),

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                this.isSaving = false;
            }
        }
    }
};
</script>
